import * as React from 'react';
import { PureIconContainer } from './utils/IconContainer';
var Calendar = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Calendar_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5.5a.5.5 0 0 0-1 0V1c-1.483.001-2.26.02-2.862.327A3 3 0 0 0 .327 2.638C.057 3.168.01 3.835.002 5H0v6.2c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C2.28 16 3.12 16 4.8 16h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C16 13.72 16 12.88 16 11.2V5h-.002c-.008-1.165-.055-1.831-.325-2.362a3 3 0 0 0-1.311-1.311C13.76 1.02 12.982 1.001 11.5 1V.5a.5.5 0 0 0-1 0V1h-5V.5ZM14.998 5a15.129 15.129 0 0 0-.036-1.089c-.035-.438-.1-.663-.18-.819a2 2 0 0 0-.874-.874c-.156-.08-.38-.145-.819-.18C12.693 2.005 12.196 2 11.5 2v1a.5.5 0 0 1-1 0V2h-5v1a.5.5 0 0 1-1 0V2c-.696 0-1.193.005-1.589.038-.438.035-.663.1-.819.18a2 2 0 0 0-.874.874c-.08.156-.145.38-.18.819-.024.294-.033.643-.036 1.089h13.996ZM1 6v5.2c0 .857 0 1.439.038 1.889.035.438.1.663.18.819a2 2 0 0 0 .874.874c.156.08.38.145.819.18C3.361 15 3.943 15 4.8 15h6.4c.857 0 1.439 0 1.889-.038.438-.035.663-.1.819-.18a2 2 0 0 0 .874-.874c.08-.156.145-.38.18-.819.037-.45.038-1.032.038-1.889V6H1Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Calendar_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
export default Calendar;